const config = {
  merchant: "gi8viet",
  language: "VI",
};
export default config;
